<template>
  <v-layout row>
    <v-flex
      xs12
      sm8
      offset-sm2
      md6
      offset-md3
      lg6
      offset-lg3
      xl6
      offset-xl3
    >
      <div class="title">
        <h3 class="headline mb-0">{{ $t('sign_up') }}</h3>
      </div>
      <div class="text-xs-center mt-3">
        {{ $t('sign_up_social2') }}
      </div>
<!--      <div class="social ma-3">-->
<!--        <login-with-social-->
<!--          provider="facebook"-->
<!--          :url="url.facebook"-->
<!--          from-register-->
<!--        />-->
<!--      </div>-->
      <div class="social ma-3">
        <login-with-social
          provider="google"
          :url="url.google"
          from-register
        />
      </div>
      <v-divider class="mt-4 mb-3" />
      <div class="text-xs-center">
        {{ $t('sign_up_email2') }}
      </div>
      <v-card
        flat
        :color="theme.login_bg_color"
      >
        <progress-bar :show="busy"></progress-bar>
        <form
          @submit.prevent="register"
          @keydown="form.onKeydown($event)"
        >
          <v-card-text>
            <!-- First Name -->
            <text-input
              :form="form"
              :label="$t('first_given_name')"
              :v-errors="errors"
              :value.sync="form.name"
              browser-autocomplete="name"
              counter="50"
              name="name"
              v-validate="'required|max:50'"
            ></text-input>

            <!-- Last Name -->
            <text-input
              :form="form"
              :label="$t('last_family_name')"
              :v-errors="errors"
              :value.sync="form.name2"
              browser-autocomplete="name2"
              counter="50"
              name="name2"
              v-validate="'required|max:50'"
            ></text-input>

            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              v-validate="'required|email'"
            ></email-input>

            <!-- Password -->
            <password-input
              :form="form"
              :label="$t('password')"
              :hint="$t('password_length_hint')"
              :v-errors="errors"
              :value.sync="form.password"
              browser-autocomplete="new-password"
              v-on:eye="eye = $event"
              name="password"
              v-validate="'required|min:6|verify_password'"
            ></password-input>

            <text-input
              :form="form"
              label="referral_id"
              :v-errors="errors"
              :value.sync="form.referral_id"
              browser-autocomplete="referral_id"
              name="referral_id"
              :disabled="true"
              v-validate="'max:50'"
              style="pointer-events: none;"
            ></text-input>
            <div style="position:relative;top:-10px">{{form.referral_name}}</div>


            <!-- Password Confirmation -->
            <!-- <password-input :form="form" :hide="eye" :label="$t('confirm_password')" :v-errors="errors" :value.sync="form.password_confirmation" browser-autocomplete="new-password" data-vv-as="password" hide-icon="true" name="password_confirmation" v-validate="'required|confirmed:password'"></password-input> -->

            <!-- Terms & Conditions -->
            <div class="terms">
              {{ config.pdpa_text }}
            </div>

            <div class="terms">
              {{ config.pdpa_consent_text }}
            </div>

            <div
              class="term-link"
              v-html="config.pdpa_privacy_text"
            >
            </div>
            <div
              class="term-link"
              v-if="parseInt(gid) !== 256"
            >
              <v-checkbox
                v-model="checkbox"
                required
                :rules="[v => !!v || 'You must agree to continue!']"
              >
                <span slot="label">
                  I have read and agree to the <a :href="tnc_link" target="_blank">terms and conditions</a>.
                </span>
              </v-checkbox>
            </div>

            <hidden-input
              name="loyalty_group_id"
              :value="form.loyalty_group_id"
            ></hidden-input>

            <submit-button
              block
              :form="form"
              dark
              :disabled="disabled"
              :color="theme.btn_color_primary"
              :label="$t('sign_up')"
            ></submit-button>
          </v-card-text>
        </form>
      </v-card>
      <div class="login">
        {{ $t('have_account') }} <router-link :to="{ name: 'login' }">{{ $t('sign_in') }}</router-link>
      </div>
      <div
        class="home"
        v-if="allowCheckout.guest"
      >
        <router-link :to="{ name: 'welcome' }">{{ $t('continue_as_guest') }}</router-link>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'
import LoginWithSocial from '~/components/LoginWithSocial'

export default {
  name: 'register-view',
  layout: 'default',
  metaInfo () {
    return { title: this.$t('sign_up') }
  },
  components: {
    'login-with-social': LoginWithSocial
  },
  data: () => ({
    form: new Form({
      name: '',
      name2: '',
      email: '',
      password: '',
      // password_confirmation: ''
      checkbox: false,
      referral_name: '',
      referral_id: '',
      loyalty_group_id: '',
    }),
    eye: true,
    // term1: null,
    // term2: null,
    disabled: false,
    busy: false,
    checkbox: null,
    url: {
      facebook: '',
      google: ''
    },
    tnc_link: null
  }),
  computed: {
    ...mapGetters('config', [
      'gid', 'loyaltyGroupId', 'theme', 'allowCheckout', 'config'
    ]),
    ...mapGetters('member', [
      'isMember'
    ])
  },
  methods: {
    async register () {
      if (await this.formHasErrors()) return
      this.busy = true

      try {
        // Register the user.
        const { data } = await this.form.post('/api/register')

        // Log in the user.
        const { data: { token }} = await this.form.post('/api/login')

        // Save the token.
        this.$store.dispatch('auth/saveToken', { token })

        // Update the user.
        await this.$store.dispatch('auth/updateUser', data)

        this.busy = false

        // Redirect to more data collection.
        this.$router.push({ name: 'register2' })
      } catch (e) {
        this.busy = false
      }
    },
    async callBackFromSocial (e) {
      if (e.origin !== window.origin || !e.data.token) {
        return
      }

      this.$store.dispatch('auth/saveToken', {
        token: e.data.token
      })

      await this.$store.dispatch('auth/fetchUser')
      await this.$store.dispatch('member/fetchProfile')

      if (this.isMember) {
        // Ensure we can really find this member from Loyalty db
        const result = await axios.post('/api/member/login', {
          loyalty_group_id : this.loyaltyGroupId
        })
        // Happens when restaurant's group id is manually changed in loyalty DB
        if (result.data === 0) {
          const result2 = await axios.post('/api/member/reset', {
            loyalty_group_id: this.loyaltyGroupId,
          })
          await this.$store.dispatch('auth/saveUser', result2.user)
          this.$store.dispatch('member/resetMemberData')
          this.$router.push({ name: 'register2' })
        } else {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.$router.push({ name: 'register2' })
      }
    }
  },
  async beforeMount () {
    this.tnc_link = this.config.tnc_link ? this.config.tnc_link : 'https://mobileorder.aptsys.com.sg/tnc'
    this.url.facebook = await this.$store.dispatch('auth/fetchOauthUrl', {
      provider: 'facebook'
    })
    this.url.google = await this.$store.dispatch('auth/fetchOauthUrl', {
      provider: 'google'
    })
    window.addEventListener('message', this.callBackFromSocial, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.callBackFromSocial)
  },
  created () {
    const dict = {
      custom: {
        // term1: {
        //   required: 'Your must agree to continue'
        // },
        // term2: {
        //   required: 'Your must agree to continue'
        // }
      }
    }
    this.$validator.localize('en', dict)
    this.form.referral_id = this.$route.params.referral_id
    this.form.referral_name = this.$route.params.referral_name
    this.form.loyalty_group_id = this.loyaltyGroupId;
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-top: 15px;
}
.login {
  text-align: center;
}
.terms {
  margin-top: 15px;
  /* color: #666; */
}
.term-link {
  margin-top: 10px;
  margin-bottom: 24px;
}
.home {
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/register.vue